import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import gigJobPartiesMixin from './gigJobPartiesMixin'
import waitForRefreshApplicationMixin from './waitForRefreshApplicationMixin'
import { DISPUTE_GIG_TYPE } from '@/constants/components/CreateDispute'
import { GigJobStages } from '@/constants/gig/gigJobStages'
import snackMixin from '@/mixins/snackMixin'
import { RootState } from '@/store'
import { addSeconds, convertToLocal, isBefore } from '@/utils/date'

export default Vue.extend({
  mixins: [gigJobPartiesMixin, snackMixin, waitForRefreshApplicationMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.gigChat.application.value,
    }),
    deadline() {
      return addSeconds(convertToLocal(this.application?.job?.created_at), this.application.offer?.deadline)
    },
    deadlineHasCome() {
      return isBefore(this.deadline, Date.now())
    },
    hasCreateDispute() {
      return this.isWorker && this.application?.job?.stage === GigJobStages.IN_PROGRESS && this.deadlineHasCome
    },
  },
  methods: {
    ...mapActions({
      openModal: 'ui/openModal',
    }),
    createDispute() {
      if (!this.application.job) return

      if (this.deadlineHasCome) {
        this.openModal({
          component: 'lx-lazy-modal',
          props: {
            factory: import(/* webpackChunkName: "job-modals" */ '@/modals/CreateDispute/CreateDispute.vue'),
            title: 'Open a dispute',
            props: {
              disputeData: {
                type: DISPUTE_GIG_TYPE,
                id: this.application.job.id,
                name: this.application.gig.name,
                blockchain: this.application.job.blockchain,
              },
              onSuccess: this.waitRefreshApplication,
            },
          },
        })
      } else {
        this.openSnackbar({
          type: this.SnackTypes.FAILURE,
          text: `You can only initiate a dispute once the deadline has been reached.`,
        })
      }
    },
  },
})
